export default __webpack_public_path__ + "static/media/Handl Health - Emblem - 3D Blue.7deaeecf.png";